const ProcessLogsFilter = () => {
  return <div>ProcessLogsFilter</div>;
};

export default ProcessLogsFilter;
